var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogPaused = function SvgLogPaused(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19319_36174)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.4375,
    y: 4.44666,
    width: 2.66667,
    height: 7.11333,
    rx: 1.33333,
    fill: "#FF9F0A",
    fillOpacity: 0.5,
    stroke: "#FF9F0A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.88672,
    y: 4.44666,
    width: 2.66667,
    height: 7.11333,
    rx: 1.33333,
    fill: "#FF9F0A",
    fillOpacity: 0.5,
    stroke: "#FF9F0A",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19319_36174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgLogPaused as ReactComponent };
export default __webpack_public_path__ + "log-paused.svg";